<template>
  <div
    class="space-y-3 py-1"
    role="status"
    :aria-label="ariaLabel"
  >
    <div
      v-if="showRoundHeader"
      class="flex items-center gap-2 px-1"
    >
      <span
        class="w-5 h-5 rounded-full bg-slate-200 dark:bg-slate-700 animate-pulse"
      ></span>
      <span
        class="h-3 w-24 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
      ></span>
    </div>

    <div
      v-for="n in count"
      :key="`negotiation-history-skeleton-${n}`"
      class="rounded-lg border border-slate-200/80 dark:border-slate-700/80 p-3"
    >
      <div class="flex items-start gap-2.5">
        <span
          class="w-7 h-7 rounded-full bg-slate-200 dark:bg-slate-700 animate-pulse shrink-0"
        ></span>
        <div class="flex-1 min-w-0 space-y-2">
          <div class="flex items-start justify-between gap-3">
            <span
              class="h-3 w-20 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
            ></span>
            <span
              class="h-3 w-16 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
            ></span>
          </div>
          <span
            class="block h-3 w-3/4 max-w-[14rem] rounded bg-slate-100 dark:bg-slate-800 animate-pulse"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  count: { type: Number, default: 2 },
  showRoundHeader: { type: Boolean, default: false },
  ariaLabel: { type: String, default: "Loading" },
});
</script>
